import { Stack } from "@mui/material";
import React from "react";
import Runners from "../runners/Runners";

function RunnersDashboard() {
  return (
    <Stack>
      <Runners />
    </Stack>
  );
}

export default RunnersDashboard;
